import cn from 'classnames'
import {FC, PropsWithChildren} from 'react'

import {IncludedPriceBenefits} from '@/components/common/benefits/IncludedPriceBenefits'
import {getPricingContent} from '@/content/pricing'
import {EXPAND_TRANSITION} from '@/theme/cssTransitions'
import {
  CONTAINER_PADDING,
  CONTAINER_PADDING_MOBILE,
  HEADER_CONTENT_HEIGHT_MOBILE,
} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

import {useCountryCardsList} from '../hooks/useCountryCardsList'
import {PricingCalculatorCtaButton} from '../PricingCalculatorCtaButton'
import {PricingCountryCalculatorProps} from '../PricingCountryCalculator'
import {PricingCountryCheckboxList} from '../PricingCountryCheckboxList'

export const PricingCountryCalculatorMobile: FC<
  PropsWithChildren<PricingCountryCalculatorProps>
> = ({
  selectedJurisdictions,
  setSelectedJurisdictions,
  linkHref,
  trackClickEvent,
  startButtonText,
  continueButtonText,
  estimationCard,
  discountBanner,
  getJurisdictionPricing,
  allowedJurisdictions,
  allowEuMemberSelection,
  children,
}) => {
  const {description} = getPricingContent().calculator
  const countryCardsList = useCountryCardsList(6, allowedJurisdictions)

  return (
    <>
      <div className="summary">{estimationCard}</div>
      <div className="description">
        <IncludedPriceBenefits description={description} color={theme.palette.text.light} />
      </div>
      {discountBanner}
      {children}
      <div>
        <div className="list">
          <PricingCountryCheckboxList
            selectedJurisdictions={selectedJurisdictions}
            setSelectedJurisdictions={setSelectedJurisdictions}
            countryCardsList={countryCardsList}
            getJurisdictionPricing={getJurisdictionPricing}
            allowEuMemberSelection={allowEuMemberSelection}
          />
        </div>
        <div className={cn('button-wrapper', selectedJurisdictions.length > 0 && 'floating')}>
          <PricingCalculatorCtaButton
            linkHref={linkHref}
            trackClickEvent={trackClickEvent}
            startButtonText={startButtonText}
            continueButtonText={continueButtonText}
            hasSelectedJurisdictions={selectedJurisdictions.length > 0}
          />
        </div>
      </div>

      <style jsx>{`
        .summary {
          position: sticky;
          top: 0;
          background-color: ${theme.palette.background.default};
          margin: 0 -${CONTAINER_PADDING} ${theme.spacing[4]};
          padding: 0 ${CONTAINER_PADDING};
          z-index: 2;
        }

        .list {
          flex: 1;
          margin-top: ${theme.spacing[4]};
        }

        .button-wrapper {
          position: sticky;
          bottom: calc(-${theme.spacing[6]} * 2 - ${theme.spacing[6]});
          margin-top: ${theme.spacing[6]};
          transition: bottom ${EXPAND_TRANSITION}ms ease-in-out;
        }

        .floating {
          bottom: calc(${HEADER_CONTENT_HEIGHT_MOBILE} + ${theme.spacing[8]});
        }

        .description {
          margin-bottom: ${theme.spacing[4]};
        }

        @media ${MOBILE_SCREENSIZE} {
          .summary {
            margin: 0 -${CONTAINER_PADDING_MOBILE} ${theme.spacing[2]};
            padding: 0 ${CONTAINER_PADDING_MOBILE};
          }
          .description {
            margin-top: ${theme.spacing[3.5]};
          }
        }
      `}</style>
    </>
  )
}
